export default __webpack_public_path__ + "static/media/jump@2x.299c3daa.png";